import { useCallback, useEffect, useState } from "react";
import PayersService from "../../../../../../../../../../services/accounts/payers";
import ContractsService from "../../../../../../../../../../services/accounts/contracts";

export const useFetchListData = (contractId: string, type: 0 | 1 | 2) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [data, setData] = useState<any[]>([]);

  const fetchData = useCallback(async () => {
    try {
      const request = {
        pageNumber: 1,
        pageSize: 1000,
        contractId,
      };

      const res: any[] =
        type === 1
          ? await PayersService.fetchAll(request)
          : await ContractsService.fetchPayees(request);

      setData(res);

      setIsLoading(false);
    } catch {
      setIsLoading(false);
    }
  }, [contractId, type]);

  useEffect(() => {
    fetchData();
  }, [type, fetchData]);

  return { data, isLoading };
};
